import React from 'react';

import { Icon } from '@rbilabs/universal-components';

import { Box } from 'components/ui';
import { primitive } from 'styles/constants';

import { DELIVERY_PROGRESS_COLOR } from './constants';

interface ProgressCheckpointProps {
  isActive: boolean;
  whiteVariant?: boolean;
}

const ProgressCheckpoint: React.FC<ProgressCheckpointProps> = ({ isActive, whiteVariant }) => {
  const variant = whiteVariant && !isActive ? 'checkMarkWhite' : 'checkMark';
  return (
    <Box>
      <Icon variant={variant} color={isActive ? DELIVERY_PROGRESS_COLOR : primitive.$greyFive} />
    </Box>
  );
};

export default ProgressCheckpoint;
